import React from 'react';
import classNames from 'classnames';

import css from './IconShow.module.css';

export const IconShow = ({ rootClassName, className }) => {
  const classes = classNames(rootClassName || css.root, className);

  return (
    <svg
      className={classes}
      xmlns="http://www.w3.org/2000/svg"
      xmlSpace="preserve"
      style={{
        shapeRendering: 'geometricPrecision',
        textRendering: 'geometricPrecision',
        imageRendering: 'optimizeQuality',
        fillRule: 'evenodd',
        clipRule: 'evenodd',
      }}
      viewBox="0 0 1706.66 1706.66"
    >
      <defs>
        <style>{'.fil0{fill:#000}'}</style>
      </defs>
      <g id="Layer_x0020_1">
        <path
          d="M1448.43 1071.43H258.23c-19.39 0-35.17-15.78-35.17-35.17v-82.44c0-19.39 15.78-35.17 35.17-35.17h1190.2c19.39 0 35.17 15.78 35.17 35.17v82.44c0 19.39-15.78 35.17-35.17 35.17zm-1185.37-40.02h1180.52v-72.75H263.06v72.75z"
          className="fil0"
        />
        <path
          d="M344.78 1180.36c-67.12 0-121.72-54.61-121.72-121.72 0-15.38-3.96-42.37 20-42.37 9.37 0 17.25 6.46 19.4 15.17h184.03c47.65 0 12.91 148.93-101.71 148.93zm-80.72-108.93c6.15 39 40 68.92 80.72 68.92 40.7 0 74.56-29.92 80.72-68.92H264.06z"
          className="fil0"
        />
        <path
          d="M548.2 1180.36c-114.62 0-149.36-148.94-101.7-148.94h203.41c47.65 0 12.91 148.94-101.7 148.94zm-80.71-108.93c14.38 91.17 147.03 91.19 161.44 0H467.49z"
          className="fil0"
        />
        <path
          d="M751.63 1180.36c-114.64 0-149.37-148.94-101.72-148.94h203.43c47.65 0 12.91 148.94-101.7 148.94zm-80.72-108.93c6.15 39 40 68.92 80.72 68.92 40.71 0 74.56-29.92 80.71-68.92H670.91z"
          className="fil0"
        />
        <path
          d="M955.04 1180.36c-114.62 0-149.36-148.94-101.7-148.94h203.41c47.65 0 12.93 148.94-101.71 148.94zm-80.7-108.93c14.37 91.17 147.02 91.19 161.44 0H874.34z"
          className="fil0"
        />
        <path
          d="M1158.46 1180.36c-114.63 0-149.37-148.94-101.72-148.94h203.41c47.65 0 12.93 148.94-101.69 148.94zm-80.72-108.93c14.38 91.17 147.03 91.19 161.45 0h-161.45z"
          className="fil0"
        />
        <path
          d="M1422.06 1706.66H285.95c-11.04 0-20-8.97-20-20v-545.17c0-26.33 40-26.32 40 0v525.16l1096.11.02v-526.14c0-26.33 40-26.32 40 0v546.14c.02 11.04-8.95 20-20 20zM1425.36 958.67c-2.54 0-5.11-.49-7.61-1.51-535.39-220.72-586.48-611.04-588.39-627.53-3.02-26.12 36.61-30.77 39.74-4.63.54 4.46 51.89 384.1 563.91 595.19 20.2 8.33 14.06 38.48-7.64 38.48z"
          className="fil0"
        />
        <path
          d="M273.08 958.67c-21.69 0-27.83-30.17-7.62-38.5 513.82-211.83 563.46-591.35 563.9-595.15 3.03-26.13 42.76-21.56 39.74 4.6-1.92 16.51-53 406.81-588.39 627.53a19.77 19.77 0 0 1-7.62 1.52zM1361.89 1180.36c-114.65 0-149.39-148.94-101.74-148.94h184.01c5.46-22.11 39.39-19.64 39.4 5.76l.02 21.43c.03 67.13-54.58 121.75-121.69 121.75zm-80.72-108.93c14.37 91.16 147.04 91.19 161.46 0h-161.46zM1079.05 1706.66h-450.1c-11.04 0-20-8.97-20-20v-225.07c0-135.12 109.93-245.07 245.07-245.07 135.12 0 245.05 109.94 245.05 245.07v225.07c-.02 11.04-8.97 20-20.02 20zm-430.1-40h410.09v-205.07c0-113.07-91.97-205.05-205.04-205.05s-205.07 91.98-205.07 205.05v205.07h.02z"
          className="fil0"
        />
        <path
          d="M628.96 1706.66c-20.89 0-27.78-28.37-9.04-37.86 138.92-70.24 184.51-221.69 203.98-286.36 8.77-29.11 12.77-42.41 30.11-42.41s21.35 13.29 30.1 42.39c91.19 303.07 237.95 263.44 212.81 313.24-4.99 9.87-17.06 13.82-26.88 8.83-136.07-68.79-191.68-208.41-216.02-284.01-24.36 75.58-79.97 215.22-216.04 284.01a19.81 19.81 0 0 1-9.01 2.16zM1304.36 1706.66c-11.04 0-20-8.97-20-20V1142.4c0-26.33 40-26.32 40 0v544.26c0 11.04-8.96 20-20 20zM1187.38 1706.66c-11.04 0-20-8.97-20-20v-530.52c0-26.33 40-26.32 40 0v530.52c0 11.04-8.96 20-20 20zM403.64 1706.66c-11.04 0-20-8.97-20-20v-545.15c0-26.33 40-26.32 40 0v545.15c0 11.04-8.96 20-20 20zM520.63 1706.66c-11.04 0-20-8.97-20-20v-530.13c0-26.33 40-26.32 40 0v530.13c0 11.04-8.94 20-20 20zM673.32 958.67c-21.48 0-27.81-29.62-8.07-38.3 84.63-37.24 145.54-384.61 164.06-594.8 2.33-26.36 42.15-22.65 39.85 3.51-5.11 58.06-53.85 568.95-187.79 627.89-2.61 1.16-5.37 1.7-8.05 1.7z"
          className="fil0"
        />
        <path
          d="M1025.12 958.67c-2.68 0-5.43-.54-8.04-1.7-133.94-58.94-182.66-569.84-187.78-627.89-2.31-26.24 37.53-29.72 39.85-3.51 18.54 210.21 79.46 557.58 164.06 594.8 19.76 8.69 13.4 38.3-8.08 38.3z"
          className="fil0"
        />
        <path
          d="M849.23 347.32c-11.04 0-20-8.96-20-20V20.02c0-26.33 40-26.33 40 0v307.3c0 11.04-8.96 20-20 20z"
          className="fil0"
        />
        <path
          d="M849.25 218.18c-21.38 0-27.79-29.41-8.24-38.24l157.04-70.84-157.04-70.86c-23.99-10.82-7.56-47.31 16.46-36.46l197.43 89.08c15.67 7.07 15.67 29.41 0 36.47-24.01 10.82-195.52 90.84-205.65 90.84zM395 1071.43c-11.04 0-20-8.97-20-20V938.67c0-26.33 40-26.32 40 0v112.76c0 11.04-8.94 20-20 20zM578.35 1071.43c-11.04 0-20-8.97-20-20V938.67c0-26.33 40-26.32 40 0v112.76c0 11.04-8.95 20-20 20zM761.67 1071.43c-11.04 0-20-8.97-20-20V938.67c0-26.33 40-26.32 40 0v112.76c-.01 11.04-8.94 20-20 20zM945 1071.43c-11.04 0-20-8.97-20-20V938.67c0-26.33 40-26.32 40 0v112.76c0 11.04-8.96 20-20 20zM1128.32 1071.43c-11.04 0-20-8.97-20-20V938.67c0-26.33 40-26.32 40 0v112.76c0 11.04-8.96 20-20 20zM1311.64 1071.43c-11.04 0-20-8.97-20-20V938.67c0-26.33 40-26.32 40 0v112.76c0 11.04-8.96 20-20 20zM854.01 1380.06c-11.04 0-20-8.97-20-20v-123.52c0-26.33 40-26.32 40 0v123.52c0 11.03-8.96 20-20 20z"
          className="fil0"
        />
      </g>
    </svg>
  );
};

export default IconShow;
